<template>
	<div>
		<el-dialog :title="lang.select_the_teaching_class" :visible.sync="show" :append-to-body="true" width="600px" height="80%"
      :before-close="handleClose" class="addNewPP2">
      <div class="check_classBox">
        <div class="check_class_right">
          <div class="check_class" :class="{ activeX: gradeId == '' }" @click="(gradeId = ''), getClass()">
            {{ lang.all }}
          </div>
          <el-tooltip placement="top" :content="item.name" v-for="(item, index) in gradeList" :key="index">
            <div class="check_class" :class="{ activeX: gradeId == item.id }" @click="(gradeId = item.id), getClass()">
              {{ item.name }}
            </div>
          </el-tooltip>
        </div>
        <div class="check_class_left">
          <div class="check_class_all_box">
            <div class="check_class_left_title">{{ lang.select_a_class }}</div>
            <div style="display: flex; align-items: center; margin-left: auto">
              <el-checkbox v-model="checkAll" @change="handleCheckAllChange" class="all_check">{{ lang.selectAll }}</el-checkbox>
            </div>
          </div>
          <!-- <div class="class_item" style="position:absolute; margin:0" v-if="grade2.length">
            <el-checkbox v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
          </div> -->
          <el-checkbox-group v-model="checkboxList2" class="check_class_item" @change="InviteChange"
            v-if="grade2.length">
            <div v-for="item in grade2" :key="item.id" class="class_item">
              <el-checkbox :label="item.id">
                {{ item.name }}
              </el-checkbox>
            </div>
          </el-checkbox-group>
          <div v-if="!grade2.length">{{ lang.noData }}</div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="close()">{{ lang.cancel }}</el-button>
        <el-button type="primary" @click="submit">{{ lang.queding }}</el-button>
      </span>
    </el-dialog>
	</div>
</template>

<script>
export default {
	data() {
		return {
			show: false,
			grade2: [],
			grade:[],
			checkList: [],
			gradeList:[],
			gradeId: "",
			checkAll:false,
			checkboxList2:[],
			isIndeterminate:false,
			classSearch:"",
		};
	},
	methods: {
		open(select) {
			this.init();
			this.getClass();
			if(select.length>0){
				this.checkboxList2 = JSON.parse(JSON.stringify(select));
			}
			this.show = true;
		},
		close() {
			this.show = false;
		},
		submit() {
			this.$emit("success",this.checkboxList2);
		},
		init(){
			this.checkboxList2 = [];
			this.gradeId = "";
			this.isIndeterminate = false;
			this.classSearch = "";
		},
		//获取班级列表
    getClass() {
      let params = {
        oid: this.$store.state.user.organizeid,
        gid: this.gradeId,
        cn: this.classSearch,
      };
      this.ajax
        .get(this.$store.state.api + "selectClassBySchoolSearch2", params)
        .then((res) => {
          if (!this.grade.length) {
            this.grade = res.data[0];
          }
          this.grade2 = res.data[0];
          this.classJuri = res.data[0];
          let _check = [];
          let _check2 = [];
          for (var i = 0; i < this.grade2.length; i++) {
            var gid = this.grade2[i].id;
            _check.push(gid);
          }
          for (var i2 = 0; i2 < this.checkboxList2.length; i2++) {
            var _id = this.checkboxList2[i2];
            if (_check.indexOf(_id) !== -1) {
              _check2.push(_id);
            }
          }
          this.checkAll = _check2.length === _check.length;
        })
        .catch((err) => {
          this.isLoading = false;
          console.error(err);
        });
    },
		InviteChange(){

		},
		handleCheckAllChange(val) {
      if (val) {
        for (var i = 0; i < this.grade2.length; i++) {
          let gid = this.grade2[i].id;
          if (this.checkboxList2.indexOf(gid) === -1) {
            this.checkboxList2.push(gid);
          }
        }
      } else {
        let _check = [];
        let _check2 = [];
        for (var i2 = 0; i2 < this.grade2.length; i2++) {
          let gid = this.grade2[i2].id;
          _check.push(gid);
        }
        for (var i3 = 0; i3 < this.checkboxList2.length; i3++) {
          var _id = this.checkboxList2[i3];
          if (_check.indexOf(_id) === -1) {
            _check2.push(_id);
          }
        }
        this.checkboxList2 = _check2;
      }
      this.isIndeterminate = false;
    },
		handleClose(done) {
			done()
		},
	},
	mounted(){
		this.getClass();
	}
};
</script>

<style scoped>
.addNewPP2>>>.el-dialog__body {
  padding: 5px 0;
}

.addNewPP2>>>.el-dialog {
  margin-top: 5vh !important;
}

.customWidth>>>.el-dialog {
  min-width: 600px !important;
}

.check_classBox {
  height: 400px;
  display: flex;
  border-top: 1.5px solid #e7ebf1;
  border-bottom: 1.5px solid #e7ebf1;
}

.check_class_right {
  width: 130px;
  border-right: 1px solid #e7ebf1;
  display: flex;
  align-items: center;
  flex-direction: column;
  height: 100%;
  overflow: auto;
  padding: 15px 0;
  box-sizing: border-box;
}

.check_class {
  width: 85%;
  border-radius: 5px;
  height: 30px;
  min-height: 30px;
  line-height: 30px;
  text-align: center;
  padding: 0 10px;
  box-sizing: border-box;
  cursor: pointer;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.check_class.activeX {
  background: #e0eafb;
  color: #3681fc;
  font-weight: 700;
}

.check_class+.check_class {
  margin-top: 15px;
}

.check_class_left {
  background: #fafafa;
  width: calc(100% - 130px);
  padding: 15px;
  box-sizing: border-box;
}

.check_class_all_box {
  display: flex;
  margin-bottom: 10px;
}

.all_check {
  display: flex;
  align-items: center;
  padding: 2px 0 0;
  margin-left: 10px;
}

.all_check>>>.el-checkbox__label {
  line-height: 18px;
}

.check_class_left_title {
  font-size: 16px;
  font-weight: 700;
}

.check_class_item {
  display: flex;
  flex-wrap: wrap;
  height: calc(100% - 45px);
  overflow: auto;
  justify-content: flex-start;
  align-items: flex-start;
  align-content: flex-start;
}


.check_class_item {
  display: flex;
  flex-wrap: wrap;
  height: calc(100% - 45px);
  overflow: auto;
  justify-content: flex-start;
  align-items: flex-start;
  align-content: flex-start;
}

.class_item:first-child {
  /* margin: 0 15px 15px 67px; */
}

.class_item {
  margin: 0 15px 15px 0;
}

.class_item:hover>>>.el-checkbox__label {
  color: #409eff;
}

.class_item>>>.el-checkbox__label {
  color: #0e1e33;
}

.class_item:hover>>>.el-checkbox__inner {
  border-color: #409eff;
}

.class_item>>>.el-checkbox,
.class_item>>>.el-checkbox__input {
  display: flex;
  align-items: center;
}
</style>
